import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { AISearchRepository } from '../../service/ai-search.repository.interface';
import { SetTechQuery } from '@/infrastructure/api-functions/interface/set-tech-query.interface';

export const SetTechQueryDTO = Symbol('SetTechQueryDTO');

export interface SetTechQueryDTO {
    fetch: AISearchRepository['setTechQuery'];
}

@injectable()
export class SetTechQueryDTOImpl implements SetTechQueryDTO {
    constructor(
        @inject(SetTechQuery)
        private readonly _setTechQueryApi: SetTechQuery,
    ) {
    }

    async fetch(value: { queryBody: string, comment?: string }[]): Promise<string> {
        const params = value.map(item => {
            return {
                query_body: item.queryBody,
                ...(item.comment && { comment: item.comment }),
            };
        });

        return await this._setTechQueryApi.setTechQuery(params);
    }
}
